import { params, const_var } from "../../redux/reducers/reducer";
import { addDiscountExclusionsInPayload, checkAdditionalChargesData, checkBuildingTypeCategory, setExtraOptionsVariables, detectDeviceInfo, extraAddOnRoofPitchPayload, updateDocOnSave } from "../../redux/reducers/utils";
import { saveQuote } from "../share_screen/screenShare.action";
import { createLeadService, createUpdateService } from "../../services/quote-order.service";
import { cleanPayload } from "../../utils/commonUtils";

function appendUtmParams(target, isFormData = false) {
	const crm = const_var.crmSetting;
	const set = isFormData
		? (k, v) => target.append(k, v)
		: (k, v) => {
				target[k] = v;
			};
	if (crm.utm_medium != undefined && crm.utm_medium != "") {
		set("utm_medium", crm.utm_medium);
	}
	if (crm.utm_term != undefined && crm.utm_term != "") {
		set("utm_term", crm.utm_term);
	}
	if (crm.utm_campaign != undefined && crm.utm_campaign != "") {
		set("utm_campaign", crm.utm_campaign);
	}
	if (crm.utm_content != undefined && crm.utm_content != "") {
		set("utm_content", crm.utm_content);
	}
	const source = crm?.utm_source ? crm.utm_source : crm.source;
	set("source", source);
}
function clearBuildingOptionFields() {
	const building = const_var.post_data["building"];
	building.welded_spacer = "";
	building.space_around_building = "";
	building.site_clear_obstacle = "";
	building.notched_lip = "";
	building.job_site_level = "";
	building.installation_ready = "";
	building.inside_city = "";
}
function syncOrderExtraItems() {
	const building = const_var.post_data["building"];
	building.surface_level = params.job_site_level;
	building.electricity = params.power_avail;

	const orderExtraItem = building.order_extra_items;
	if (orderExtraItem != undefined && orderExtraItem.surface_level != undefined && orderExtraItem.electricity != undefined && orderExtraItem.job_site_level != undefined) {
		orderExtraItem.surface_level = params.job_site_level;
		orderExtraItem.electricity = params.power_avail;
		orderExtraItem.job_site_level = params.job_site_level;
	}
}

function setAdditionalChargesAndCategory() {
	const_var.additionalChargeArr = checkAdditionalChargesData();
	const_var.post_data["building"].AdditionalCharges = const_var.additionalChargeArr;

	const check_type_category = checkBuildingTypeCategory(const_var.post_data.building.default_building_image_name);
	const_var.post_data["building"].building_category = check_type_category.type;
	const_var.post_data["building"].building_subcategory = check_type_category.name;
}

function removeNoneDrawings() {
	if (params.m_s_n == 3 && const_var.post_data?.building_data?.building?.length > 0 && const_var.post_data?.building?.engineer_drawings_name != "None") {
		const_var.post_data.building_data.building.forEach((building, index) => {
			if (building.drawings?.length > 0) {
				const findNoneIndex = building.drawings.findIndex((obj) => obj?.name.toLowerCase() == "none");
				if (findNoneIndex > -1) {
					const_var.post_data.building_data.building[index].drawings.splice(findNoneIndex, 1);
				}
			}
		});
	}
}

function dispatchQuoteUpdate(dispatch, getState, onSuccess) {
	const payload = cleanPayload(structuredClone(const_var.post_data));
	const { form_action, is_module_name, api_token, is_module_id } = const_var.crmSetting;
	const request = createUpdateService(form_action, is_module_name, payload, is_module_id);
	return request
		.then(async (response) => {
			getState()?.screenShareState?.isSharingScreen && dispatch(saveQuote(response.data));
			if (onSuccess) await onSuccess(response);
			dispatch({ type: "onQuoteSubmitApi", event: response.data });
		})
		.catch(function (error) {
			console.log(error);
		});
}

export function addLeadDetails(value) {
	return (dispatch) => {
		dispatch({
			type: "addLeadDetails",
			payload: value
		});
	};
}
export function handleSaveLatter(value) {
	return (dispatch) => {
		dispatch({
			type: "handleSaveLatter",
			payload: value
		});
	};
}
export function handleSavePublicQuote(value) {
	return (dispatch) => {
		dispatch({
			type: "handleSavePublicQuote",
			payload: value
		});
	};
}
export function SendBuildingDatatoPublicServer() {
	return (dispatch, getState) => {
		const building = const_var.post_data["building"];
		if (building?.leanto?.length > 0) {
			for (let i = 0; i <= building.leanto.length - 1; i++) {
				const lean = building.leanto[i];
				if (lean.leanto_type == 1) {
					lean.alignment = params.leanStyle.left === "gable" && params.p_d == params.lean_p_w ? "center" : const_var.TypeAlingnment[params.leantoAlignmentLeft];
				}
				if (lean.leanto_type == 2) {
					lean.alignment = params.leanStyle.right === "gable" && params.p_d == params.leanR_p_w ? "center" : const_var.TypeAlingnment[params.leantoAlignmentRight];
				}
				if (lean.leanto_type == 3) {
					lean.alignment = params.leanStyle.front === "gable" && params.p_w == params.leanF_p_w ? "center" : const_var.endLeanAlingnmentType[params.leantoAlignmentFront];
				}
				if (lean.leanto_type == 4) {
					lean.alignment = params.leanStyle.back === "gable" && params.p_w == params.leanB_p_w ? "center" : const_var.endLeanAlingnmentType[params.leantoAlignmentBack];
				}
			}
		}

		if (building?.other_building_type_name == "") {
			params.other_building_type_name = params.building_type_name + " - " + params.p_w + " x " + params.p_d + " x " + params.p_h;
			building.other_building_type_name = params.other_building_type_name;
			building.name = params.other_building_type_name;
		}
		building.building_type_name = building.other_building_type_name;
		const_var.post_data["name"] = building.other_building_type_name;

		if (building.surcharge_amount != 0) {
			building.surcharge_taxable = building.surcharge_taxable ?? 0;
		}

		if (const_var?.dealer_discount_label) {
			building.dealer_discount_label = const_var.dealer_discount_label;
		}
		if (building.discount_amount == undefined || building.discount_amount == 0) {
			const_var.manufacturer_discount_label = "";
			building.manufacturer_discount_label = "";
		}
		if (const_var?.manufacturer_discount_label && parseFloat(building.discount_amount) > 0) {
			building.manufacturer_discount_label = const_var.manufacturer_discount_label;
		}

		addDiscountExclusionsInPayload(const_var);
		building.installationsurfaceChange = true;
		building.old_permit_Fee = const_var.exact_order_permit_fee;
		building.is_showBackgroundImage = const_var.crmSetting.is_show_background;
		building.custom_distance_on_center = params.oncenter_val_with_action != "" ? params.oncenter_val_with_action : "";
		building.custom_building = const_var.b_o_J_1[params.p_b_t] == "Custom Buildings" ? 1 : const_var.hide_price_calculation;
		building.payment_mode = const_var.paymentOptionObj[params.paymentmode];

		const_var.post_data["user_id"] = const_var.crmSetting.login_user_id;
		const_var.post_data["is_quote"] = 1;
		const_var.post_data["questions"] = const_var.estimator_QuestionAnswer;
		const_var.post_data["charge_card"] = 0;
		const_var.post_data["form_type"] = "3d_v4";
		const_var.post_data["created_source"] = "3d_v4";
		const_var.post_data["is_api"] = 1;
		const_var.post_data["referral_source"] = const_var.referrer;
		const_var.post_data["page"] = const_var.crmSetting.page;
		const_var.post_data["form"] = "Quote Form";
		const_var.post_data["api_token"] = const_var.crmSetting.api_token;
		const_var.post_data["building_update"] = true;
		const_var.post_data["pdf_price_breakdown"] = const_var.order_extra_items["pdf_price_breakdown"];
		const_var.post_data = { ...const_var.post_data, ...const_var.LeadCustomerData };
		if (const_var.post_data["mobile_no"] == undefined) {
			const_var.post_data["mobile_no"] = const_var.post_data["phone_no"];
		}

		appendUtmParams(const_var.post_data);

		const_var.post_data["build_type"] = "added_building";
		const_var.post_data["billing_county"] = const_var.post_data.billing_country;
		const_var.post_data["shipping_county"] = const_var.post_data.shipping_country;
		const_var.post_data["module"] = const_var.crmSetting.is_module_name;
		const_var.post_data["module_id"] = const_var.crmSetting.is_module_id;
		const_var.post_data["sub_module"] = const_var.crmSetting.sub_module;
		const_var.post_data["sub_module_id"] = const_var.crmSetting.sub_module_id;
		const_var.post_data["building_data"] = const_var.SendAPIBuildingData;
		const_var.post_data["building_data"]["color_data"] = const_var?.color;
		const_var.post_data["building_data"]["component_data"] = const_var.componentData;
		const_var.post_data["building_data"]["siding_material_data"] = const_var.mainSidingOptions;
		const_var.post_data["estimator_domain"] = const_var.crmSetting.main_domain_url;
		const_var.post_data["pricing_data"] = const_var.isLTBuilding ? const_var.holdPricingResponse : const_var.a_p_d_a;
		const_var.post_data["is_generate_pdf"] = true;

		building.additional_note = params.additional_note;
		if (params.p_c_i && building) {
			building.insulation = "custom";
		}
		building.isUpdate4ftLegLogic = const_var.isUpdate4ftLegLogic || false;
		syncOrderExtraItems();
		clearBuildingOptionFields();
		setAdditionalChargesAndCategory();

		building.additional_note = params.additional_note;
		building.wallOrientation = params.wallOrientation;

		if (const_var.isPublicEdit == true && params?.company_id) {
			const_var.post_data["company_id"] = params.company_id;
			const_var.post_data["estimator_domain"] = const_var.crmSetting.main_domain_url;
		}

		setExtraOptionsVariables(const_var);
		setExtraOptionsVariables(const_var);

		if ((building.insulation == "full" || building.insulation == "roof_only") && building.leanto?.length > 0) {
			building.leanto.forEach((lean) => {
				delete lean.insulation;
				delete lean.insulation_type;
				delete lean.insulation_price;
			});
		}

		// extraAddOnRoofPitchPayload();
		removeNoneDrawings();
		updateDocOnSave();

		return dispatchQuoteUpdate(dispatch, getState, async (response) => {
			const_var.post_data["module_id"] = response.data.id;
			if (response.data.status == true) {
				const_var.isPublicEdit = false;
			}
		});
	};
}
export function onquoteTextFiledChangeValue(e, name, keyword, flag, updateVar = false) {
	return (dispatch) => {
		dispatch({
			type: "onquoteTextFiledChangeValue",
			event: e,
			value: name,
			keyword: keyword,
			flagg: flag,
			updateVar: updateVar
		});
	};
}

export function onSubmit(e, isCreateFeed = false, callApiOnly = false) {
	return (dispatch) => {
		if (callApiOnly == true) {
			dispatch(onQuoteSubmitApi());
			return;
		}

		dispatch({ type: "onQuoteSubmit", event: e });

		if (const_var.checkValidate == false) {
			const_var.activeTab = "buildingtypetab";
			const_var.showReportLoading = true;

			// Split full_name into first/last
			if (const_var?.post_data?.full_name) {
				let fullname = const_var.post_data.full_name;
				let separation = fullname.split(" ");
				const_var.post_data["first_name"] = separation[0];
				const_var.post_data["last_name"] = separation[1] ? fullname.substr(fullname.indexOf(" ") + 1) : "";
			}

			if (const_var.createLeadOnly) {
				isCreateFeed = true;
			}

			if (isCreateFeed == true && (const_var.ziperrormsg == "" || const_var.ziperrormsg == undefined)) {
				const formData = new FormData();
				formData.append("first_name", const_var.post_data.first_name);
				formData.append("last_name", const_var.post_data.last_name);
				formData.append("email", const_var.post_data.email);
				formData.append("phone_no", const_var.post_data.phone_no);
				formData.append("zipcode", const_var.post_data.address[0].zipcode);
				formData.append("address", const_var.post_data.address[0].address_line_1);
				formData.append("api_token", const_var.crmSetting.api_token);
				formData.append("form", const_var.crmSetting.form);
				formData.append("build_type", "added_building");
				formData.append("page", const_var.crmSetting.page);
				formData.append("lead_source", "3D Estimator");

				appendUtmParams(formData, true);

				return createLeadService(formData)
					.then(function (response) {
						const_var.preQuoteApiCalled = true;
						const_var.preQuoteError = response.data.status != true;
						if (response.data.status == true) {
							dispatch(setThankYouForSaveLaterValue(true, true));
						}
						const_var.showReportLoading = false;
						return true;
					})
					.catch(function (error) {
						const_var.preQuoteApiCalled = true;
						const_var.preQuoteError = true;
						const_var.showReportLoading = false;
						return false;
					});
				// return axios.post(const_var.crmSetting.api_post_url + '/api/v1/create-lead', formData, {
				//   headers: { 'content-type': 'multipart/form-data' },
				// });
			}

			if (isCreateFeed == false) {
				dispatch(onQuoteSubmitApi(e));
			}
		}
	};
}

export function onQuoteSubmitApi(e) {
	// Discount labels
	if (const_var?.dealer_discount_label) {
		const_var.post_data["building"].dealer_discount_label = const_var.dealer_discount_label;
	}
	if (const_var?.manufacturer_discount_label && parseFloat(const_var.post_data["building"].discount_amount) > 0) {
		const_var.post_data["building"].manufacturer_discount_label = const_var.manufacturer_discount_label;
	}
	if (const_var?.crmSetting?.is_zipcode_screen == true) {
		const_var.post_data["building"].state_mfg_zipcode = const_var.state_mfg_zipcode;
	}

	const_var.post_data["building"].installationsurfaceChange = true;
	const_var.post_data["building"].old_permit_Fee = const_var.exact_order_permit_fee;
	const_var.post_data["building"].selectedBuildingUniqId = const_var.selectedBuildingUniqId;

	if (const_var?.editAPIDataByResponse?.data?.main_created_at != undefined) {
		const_var.post_data["building"].create_at_date = const_var?.editAPIDataByResponse?.data?.request_data?.building?.create_at_date ?? const_var?.editAPIDataByResponse?.data?.main_created_at;

		const_var.post_data.main_created_at = const_var.editAPIDataByResponse.data.main_created_at;
	}

	const_var.post_data["building"].additional_note = params.additional_note;
	const_var.post_data["is_generate_pdf"] = true;

	if (params.p_c_i && const_var.post_data && const_var.post_data.building) {
		const_var.post_data.building.insulation = "custom";
	}

	const_var.post_data["building"].isUpdate4ftLegLogic = const_var.isUpdate4ftLegLogic || false;

	if ((params.p_r_o || params.p_f_i) && const_var.post_data?.building?.leanto?.length > 0) {
		const updatedLeandata = const_var.post_data.building.leanto.map(({ insulation_type, insulation_price, ...rest }) => ({ ...rest }));
		const_var.post_data.building.leanto = updatedLeandata;
		const_var.post_data.building.leanto.insulation = "";
	}

	syncOrderExtraItems();
	clearBuildingOptionFields();
	setAdditionalChargesAndCategory();

	if (const_var.isKLinkEnable && const_var.post_data["building"].order_extra_items?.additional_note != undefined) {
		delete const_var.post_data["building"].order_extra_items.additional_note;
	}

	if ((const_var.post_data?.building?.insulation == "full" || const_var.post_data?.building?.insulation == "roof_only") && const_var.post_data?.building?.leanto?.length > 0) {
		const_var.post_data?.building?.leanto.forEach((lean) => {
			delete lean.insulation;
			delete lean.insulation_type;
			delete lean.insulation_price;
		});
	}

	const_var.post_data["building"]["device_details"] = detectDeviceInfo();
	const_var.post_data["building"].additional_note = params.additional_note;

	// extraAddOnRoofPitchPayload();
	updateDocOnSave();

	const_var.post_data.building.is_edit_extra_labour = const_var.is_edit_extra_labour || false;
	const_var.post_data["building"].isUpdate4ftLegLogic = const_var.isUpdate4ftLegLogic || false;

	if (const_var.post_data["building"].other_building_type_name != undefined) {
		const_var.post_data["building"].building_type_name = const_var.post_data["building"].other_building_type_name;
	}
	if (params.company_id) {
		const_var.post_data["company_id"] = params.company_id;
	}

	const_var.post_data["building"].wallOrientation = params.wallOrientation;
	removeNoneDrawings();
	addDiscountExclusionsInPayload(const_var);

	return (dispatch, getState) => {
		const isSpecialDomain = const_var.crmSetting.main_domain_url == "keensbuildings.com" || const_var.crmSetting.main_domain_url == "hintonbuildings.com";

		if (isSpecialDomain) {
			setExtraOptionsVariables(const_var);
			return dispatchQuoteUpdate(dispatch, getState, async (response) => {
				await sendZapierWebhook(response);
			});
		} else {
			if (params.p_c_i && const_var.post_data?.building) {
				const_var.post_data.building.insulation = "custom";
			}
			const_var.post_data["building"].isUpdate4ftLegLogic = const_var.isUpdate4ftLegLogic || false;
			const_var.additionalChargeArr = checkAdditionalChargesData();
			const_var.post_data["building"].AdditionalCharges = const_var.additionalChargeArr;
			setExtraOptionsVariables(const_var);
			return dispatchQuoteUpdate(dispatch, getState);
		}
	};
}
async function sendZapierWebhook(response) {
	const URLHinton = "https://hooks.zapier.com/hooks/catch/1680435/2ay9vzs/";
	const URLkeens = "https://hooks.zapier.com/hooks/catch/16508503/2tlkngj/";

	const sub_order_total_keen = const_var.BuildingPriceArrar["sub_order_total"] !== undefined ? const_var.BuildingPriceArrar["sub_order_total"] : 0;

	const zapPayload = {
		first_name: const_var.post_data.first_name,
		last_name: const_var.post_data.last_name,
		email: const_var.post_data.email,
		phone: const_var.post_data.phone_no,
		installation_zip: const_var.post_data.address[0].zipcode,
		deal_name: `${const_var.post_data.building.length}X${const_var.post_data.building.width}X${const_var.post_data.building.height} ${const_var.post_data.building.building_type_name} ${response.data.quote_string}`,
		product_type: "Metal Building/Carport",
		building_type: const_var.post_data.building.building_type_name,
		building_width: const_var.post_data.building.width,
		building_length: const_var.post_data.building.length,
		building_height: const_var.post_data.building.height,
		framing_gauge: `${const_var.post_data.building.gauge} Gauge`,
		building_certification: const_var.post_data.building.certificate_name,
		building_manufacture: const_var.post_data.building.manufacturer_name,
		installation_surface: const_var.post_data.building.installation_surface,
		roof_style: const_var.post_data.building.roof_style_name,
		roof_pitch: const_var.post_data.building.roof_pitch,
		roof_color: const_var.post_data.building.roof_color.name,
		trim_color: const_var.post_data.building.trim_color.name,
		wall_color: const_var.post_data.building.wall_color.name,
		wainscot_color: const_var.post_data.building.wainscot !== undefined ? const_var.post_data.building.wainscot.name : "",
		components: "",
		building_quote: response.data.pdf_url,
		building_msrp: 0,
		manufacturer_discount: const_var.post_data["building"].discount_amount,
		subtotal: sub_order_total_keen,
		quote_id: response.data.quote_string,
		deal_id: response.data.quote_string,
		questions: const_var.post_data.questions
	};

	if (const_var.crmSetting.main_domain_url == "hintonbuildings.com") {
		appendUtmParams(zapPayload);
	}

	const zapURL = const_var.crmSetting.main_domain_url == "hintonbuildings.com" ? URLHinton : URLkeens;
	try {
		const res = await fetch(zapURL, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(zapPayload),
			mode: "no-cors"
		});
		if (!res.ok) throw new Error("Network res was not ok");
		const resp = await res.json();
		console.log(resp);
	} catch (error) {
		console.log("There was a problem with the fetch operation:", error);
	}
}
export function setThankYouForSaveLaterValue(val, createLead = undefined) {
	return (dispatch) => {
		dispatch({
			type: "setThankYouForSaveLaterValue",
			val: val,
			createLead: createLead
		});
	};
}

export function keenBuildingRTO(val) {
	return (dispatch) => {
		dispatch({
			type: "keenBuildingRTO",
			val: val
		});
	};
}
